"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
exports.AspectRatioLockButton = ({ translate, disabled, locked, ratio, originalRatio, onLockedChange, }) => (hyperapp_1.h("e-tooltip", { content: disabled
        ? translate('aspectRatioLockButtonTooltipDisabled')
        : `
        ${locked ? translate('aspectRatioLockButtonTooltipUnlock') : translate('aspectRatioLockButtonTooltipLock')}
        ${ratio ? `<br/>- ${translate('aspectRatioLockButtonTooltipRatio', [ratio])}` : ''}
        ${originalRatio ? `<br/>- ${translate('aspectRatioLockButtonTooltipOriginalRatio', [originalRatio])}` : ''}
      ` },
    hyperapp_1.h("button", { className: "e-btn e-btn-onlyicon e-btn-borderless", onclick: () => onLockedChange(!locked), disabled: disabled },
        hyperapp_1.h("e-icon", { icon: locked ? 'lock' : 'e-unlock' }))));
//# sourceMappingURL=aspect-ratio-lock-button.js.map